
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/index_v1",
      function () {
        return require("private-next-pages/index_v1.tsx");
      }
    ]);
  